function init(){
  console.log("initialized");
  const customMetafieldBadges = document.querySelectorAll('.custom-metafield-badge');
  const badges = document.querySelectorAll('.badge');
  customMetafieldBadges.forEach((el)=>{
    if(el.classList.contains('pre-selected-variant')){
      el.classList.remove('visible');
    }
    else{
       el.classList.add('visible');
    }
  })
}

init();

class ProductCardSwatches extends HTMLElement {
  constructor() {
    super();

    this.swatches = this.querySelectorAll('.variant_swatch');
    this.swatchClick = this.handleSwatchClick.bind(this);
    this.showStrikeThroughPrice = this.dataset.showStrikethroughPrice;
  }

  connectedCallback() {
    const swatchWrapper = this;
    const list = swatchWrapper.swatches;

    for (const key in list) {
      if (Object.hasOwnProperty.call(list, key)) {
        const element = list[key];
        element.addEventListener('click', this.swatchClick);
      }
    }
  }

  disconnectedCallback() {
    const swatchWrapper = this;
    const list = swatchWrapper.swatches;
    for (const key in list) {
      if (Object.hasOwnProperty.call(list, key)) {
        const element = list[key];
        element.removeEventListener('click', this.swatchClick);
      }
    }
  }

  handleSwatchClick(e) {
    e.preventDefault();
    const checkedRadio = this.checkSelected(e);
    this.updateCardImage(checkedRadio);
    this.updateLinkUrl(checkedRadio);
    this.updatePrice(checkedRadio);
    this.toggleSaleBadge(checkedRadio);
  }

 checkSelected(e) {
    // Find the closest product-card-swatches element
    const swatchesElement = e.target.closest('product-card-swatches');
    if (!swatchesElement) {
        return null;
    }

    // Get the currently selected input
    const currentlySelected = swatchesElement.querySelector('input[name="colorSwatch"]:checked');
    if (currentlySelected) {
        currentlySelected.checked = false;
    }

    // Check the previous sibling input if it exists and is an input element
    if (e.target.previousSibling && e.target.previousSibling.tagName === 'INPUT') {
        e.target.previousSibling.checked = true;
    }

    // Return the newly selected input
    return swatchesElement.querySelector('input[name="colorSwatch"]:checked');
}

  updateCardImage(checkedRadio) {
    const imgUrl = checkedRadio.dataset.imageUrl;
    const cardImg = checkedRadio
      .closest('.card-wrapper.product-card-wrapper')
      .querySelector('.media')
      .querySelector('img');
    cardImg.src = imgUrl;
    cardImg.srcset = this.createNewSrcsetVals(cardImg.srcset, imgUrl);
  }

  createNewSrcsetVals(srcset, replacement) {
    const splitSrcset = srcset.split(',');
    const cleanedUrl = replacement.replace(new RegExp(/(?:_)?\d+x/, 'g'), '');
    let srcsetString = '';
    for (const url of splitSrcset) {
      const size = url.split('&width=')[1];
      size ? (srcsetString += `${cleanedUrl}&width=${size}, `) : null;
    }
    srcsetString = srcsetString.slice(0, -2);
    return srcsetString;
  }

  updateLinkUrl(checkedRadio) {
    const cardLinks = checkedRadio.closest('.card-wrapper.product-card-wrapper').querySelectorAll('a');
    for (const linkEl of cardLinks) {
      linkEl.href = checkedRadio.dataset.variantUrl;
    }
  }

  updatePrice(checkedRadio) {
    const closestCardEl = checkedRadio.closest('.card__content');
    const priceEl = closestCardEl
      .querySelector('.card__information')
      .querySelector('.card-information')
      .querySelector('.price');
    const closestPriceContainer = closestCardEl.querySelector('.price__container');
    const salePriceContainer = closestPriceContainer.querySelector('.price__sale');
    const regPriceContainer = closestPriceContainer.querySelector('.price__regular');
    const compareAtPrice = checkedRadio.dataset.variantCompareAtPrice;
    const regPrice = checkedRadio.dataset.variantPrice;

    if (this.showStrikeThroughPrice === 'true' && compareAtPrice && regPrice !== compareAtPrice) {
      priceEl.classList.add('price--on-sale');
      salePriceContainer.querySelector('.price-item.price-item--sale').textContent = regPrice;
      salePriceContainer.querySelector('.price-item.price-item--regular').textContent = compareAtPrice;
      regPriceContainer.querySelector('.price-item.price-item--regular').textContent = regPrice;
    } else {
      priceEl.classList.remove('price--on-sale');
      regPriceContainer.querySelector('.price-item.price-item--regular').textContent = regPrice;
      salePriceContainer.querySelector('.price-item.price-item--regular').textContent = regPrice;
    }
  }

  toggleSaleBadge(checkedRadio) {
    const price = checkedRadio.dataset.variantPrice;
    const compareAtPrice = checkedRadio.dataset.variantCompareAtPrice;
    const badgeEls = checkedRadio.closest('.card').querySelectorAll('.badge');
    if (compareAtPrice && price < compareAtPrice) {
      for (const badgeEl of badgeEls) {
        if(badgeEl.classList.contains('custom-metafield-badge')){
          console.log(badgeEl,"badgellll...");
          console.log("yes it is..");
           badgeEl.classList.remove('visible');
        }
        else{
           badgeEl.classList.add('visible');
        }
        
      }
    } else {
      for (const badgeEl of badgeEls) {
        if(badgeEl.classList.contains('custom-metafield-badge')){
           console.log(badgeEl,"badgellll new...")
           badgeEl.classList.add('visible');
        }
        else{
           badgeEl.classList.remove('visible');
        }
      }
    }
  }
}

customElements.define('product-card-swatches', ProductCardSwatches);
